module.exports = __webpack_public_path__ + "img/t6.458c5784.jpg";